module.exports = __webpack_public_path__ + "static/media/general-welcome-background.6c15affe.svg";